import { render, staticRenderFns } from "./AdminTopInformation.vue?vue&type=template&id=15187e40&scoped=true&"
import script from "./AdminTopInformation.vue?vue&type=script&lang=js&"
export * from "./AdminTopInformation.vue?vue&type=script&lang=js&"
import style0 from "./AdminTopInformation.vue?vue&type=style&index=0&id=15187e40&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15187e40",
  null
  
)

export default component.exports